import type {ComponentProps, FC} from 'react';
import cx from 'classnames';

interface FormFieldProps extends ComponentProps<'input'> {
  readonly field?: ComponentProps<'input'>;
}

const FormField: FC<FormFieldProps> = ({className, field = {}, ...props}) => (
  <input
    {...field}
    {...props}
    className={cx(
      'bg-transparent rounded-lg border-0 flex-1 p-2 pl-1 m-0 placeholder-light-200 text-dark-100',
      className,
    )}
  />
);

export default FormField;
